import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

const FilterModal = ({ label, dataList, selectedValues, onClose, onSave, labelMap = {} }) => {
  const [checkedValues, setCheckedValues] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    setCheckedValues(selectedValues || []);
    setFilteredList(dataList || []);

  }, [selectedValues, dataList]);

  useEffect(() => {
    const lowerSearch = searchText.toLowerCase();
    const filtered = dataList.filter(item => {
        const label = labelMap[item] || item;
        return String(label).toLowerCase().includes(lowerSearch);
      });
      
    setFilteredList(filtered);
  }, [searchText, dataList, labelMap]);

  const handleCheckboxChange = (val) => {
    setCheckedValues(prev =>
      prev.includes(val) ? prev.filter(v => v !== val) : [...prev, val]
    );
  };

  const handleApply = () => {
    onSave(checkedValues);
    onClose();
  };

  const handleClear = () => {
    setCheckedValues([]);
    onSave([]);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="relative w-[33%] max-w-2xl p-6 bg-white border rounded-lg border-2 border-gray-300 shadow-md">
        {/* Header */}
        <div className='flex w-full justify-between border-b pb-2'>
          <div className="text-[#6B7280] font-inter">{label}</div>
          <CloseIcon onClick={handleClear} className="cursor-pointer text-[#6B7280]" />
        </div>

        {/* Search box */}
        <div className="mt-4 mb-2">
          <input
            type="text"
            placeholder={`Search ${label.toLowerCase()}...`}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-300 font-inter text-sm"
          />
        </div>

        {/* Checkbox list */}
        <div className="max-h-[300px] overflow-y-auto custom-scrollbar space-y-2 pt-2">
          {filteredList.length > 0 ? (
            filteredList.map((item, index) => (
              <label key={index} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={checkedValues.includes(item)}
                  onChange={() => handleCheckboxChange(item)}
                  className="w-4 h-4 cursor-pointer"
                />
                <span className="font-inter text-sm font-bold text-[#6B7280] text-left">
                  {labelMap[item] || item}
                </span>
              </label>
            ))
          ) : (
            <div className="text-sm text-gray-500 font-inter">No matching results.</div>
          )}
        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-6 space-x-4 border-t pt-4">
          <button
            onClick={handleClear}
            className="px-4 py-2 bg-gray-50 border text-[#6B7280] rounded hover:bg-gray-100"
          >
            Clear
          </button>
          <button
            onClick={handleApply}
            className="px-4 py-2 bg-[#1E4976] text-white rounded hover:bg-[#16385c]"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
